import { render } from "./folder-carousel.vue?vue&type=template&id=443972b6"
import script from "./folder-carousel.vue?vue&type=script&lang=js"
export * from "./folder-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__